<template>
  <div class="dlrLayer-video-item">
    <div
      class="dlrLayer-video-show"
      @click="openVideo(videoId, videoName)"
      v-stat:click="{
        action: 'arhall_addvideoplay_click',
        extend: { videoid: videoId },
      }"
    >
      <div class="dlrLayer-video-post">
        <img :src="imageUrl" />
      </div>
      <a class="dlrLayer-video-trigger" href="javascript:void(0)"></a>
      <div class="dlrLayer-video-tips">
        <h3>
          <em>{{ formatPlayNum(playNum) }}</em>
          <span>次播放</span>
        </h3>
        <p>{{ formatDuration(duration) }}</p>
      </div>
    </div>
    <div class="dlrLayer-video-info">
      <h2
        class="dlrLayer-video-tit"
        v-stat:click="{
          action: 'arhall_addvideoplay_click',
          extend: { videoid: videoId },
        }"
        @click="openVideo(videoId, videoName)"
      >
        {{ videoName }}
      </h2>
      <a
        href="javascript:void(0)"
        class="dlrLayer-video-inquiry"
        v-stat:click="{ action: 'znzt_shuoche_xunjia_click' }"
        @click="sign()"
        >询底价</a
      >
    </div>
  </div>
</template>
<script>
import layerManager from '../../services/layer.manager';
import * as layerNames from '../../services/layerName';
import util from '../../utils/util';
export default {
  props: {
    videoId: {
      type: [String, Number],
      require: true
    },
    videoName: {
      type: String,
      require: true
    },
    playNum: {
      type: Number,
      require: true
    },
    imageUrl: {
      type: [String],
      default: ''
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  methods: {
    formatPlayNum (val) {
      return util.numFormat(val, 1);
    },
    formatDuration (duration) {
      const hour = Math.floor(duration / 3600);
      const minute = Math.floor((duration % 3600) / 60);
      const second = duration % 60;
      const time = minute.toString().padStart(2, '0') + ':' + second.toString().padStart(2, '0');
      if (hour < 1) {
        return time;
      }
      return hour.toString().padStart(2, '0') + ':' + time;
    },
    sign () {
      layerManager.openOrder({
        orderType2: 3,
        seriesId: 0,
        specId: 0,
        eIdKey: 'videoxunjia'
      });
    },
    openVideo (videoId, videoName) {
      layerManager.open(layerNames.VIDEO_PLAYER, { video: { name: videoName, videoId: videoId } });
      this.$emit('videoOpened');
    }
  }
};
</script>